import { useAppDispatch, useAppSelector } from "../store"
import { setUserLoading } from "../store/userReducer"
import { connectHandler } from "../utils/connectHandler"
import CtaButton from "./button/CtaButton"
import LoadingButton from "@mui/lab/LoadingButton"
import { Box, Typography, Paper, Button } from "@mui/material"
import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"

export const AuthOverlay = ({ children }) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { user, loading } = useAppSelector((state) => state.user)

  // Блокируем прокрутку страницы когда оверлей открыт
  useEffect(() => {
    document.body.classList.add('auth-overlay-open')
    return () => {
      document.body.classList.remove('auth-overlay-open')
    }
  }, [])

  const getWallet = async () => {
    dispatch(setUserLoading(true))
    try {
      await connectHandler(dispatch)
    } catch (error) {
      console.error('Connection error:', error)
    } finally {
      dispatch(setUserLoading(false))
    }
  }

  const goToHome = () => {
    navigate('/')
  }

  return (
    <Box sx={{ position: "relative" }}>
      {/* Основное содержимое страницы */}
      {children}

      {/* Оверлей авторизации - поверх всего */}
      <Box
        className="auth-overlay"
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.85)",
          backdropFilter: "blur(8px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        }}
        onClick={(e) => {
          // Предотвращаем всплытие события, чтобы нельзя было кликнуть через оверлей
          e.stopPropagation()
        }}
      >
        <Paper
          className="auth-modal"
          elevation={10}
          sx={{
            p: 5,
            maxWidth: 450,
            width: "90%",
            textAlign: "center",
            backgroundColor: "rgba(21, 21, 21, 0.95)",
            color: "white",
            border: "1px solid #555",
            borderRadius: "17px",
            boxShadow: "0px 8px 40px rgba(0, 0, 0, 0.7)",
          }}
          onClick={(e) => {
            // Предотвращаем закрытие при клике на модальное окно
            e.stopPropagation()
          }}
        >
          <Typography variant="h4" sx={{ mb: 2, fontWeight: "bold", fontFamily: "RUSBoycott, sans-serif" }}>
            Authorization Required
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, opacity: 0.85, fontSize: "1.1rem", lineHeight: 1.6 }}>
            To access this page, you need to connect your MetaMask wallet
          </Typography>

          <Box className="button-container" sx={{ display: "flex", flexDirection: "column", gap: 2, alignItems: "center" }}>
            {loading ? (
              <LoadingButton
                loading
                variant="contained"
                sx={{
                  minWidth: 200,
                  height: 50,
                  fontFamily: "RUSBoycott, sans-serif",
                  fontSize: "1rem"
                }}
              >
                Connecting...
              </LoadingButton>
            ) : (
              <CtaButton
                variant="contained"
                onClick={getWallet}
                disabled={loading}
                sx={{
                  minWidth: 200,
                  height: 50,
                  fontFamily: "RUSBoycott, sans-serif",
                  fontSize: "1rem"
                }}
              >
                Connect Wallet
              </CtaButton>
            )}

            <Button
              variant="outlined"
              onClick={goToHome}
              sx={{
                minWidth: 200,
                height: 50,
                color: "white",
                borderColor: "#555",
                fontFamily: "RUSBoycott, sans-serif",
                fontSize: "1rem",
                "&:hover": {
                  borderColor: "#777",
                  backgroundColor: "rgba(255, 255, 255, 0.05)"
                }
              }}
            >
              Go to Home
            </Button>
          </Box>
        </Paper>
      </Box>
    </Box>
  )
}
